/**
 * <dogscan-results> — animated counters, diverging bars, ratio-people fill.
 * Runs on scroll-in via IntersectionObserver; respects reduced-motion.
 * INSTALL: upload to the theme's assets/.
 */
if (!customElements.get('dogscan-results')) {
  const REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(n, decimals) {
    if (decimals) return n.toFixed(decimals).replace('.', ',');
    return Math.round(n).toLocaleString('de-DE');
  }

  function runCount(el) {
    const target = parseFloat(el.dataset.count);
    const decimals = el.dataset.decimals === '1' ? 1 : 0;
    const suffix = el.dataset.suffix || '';
    const wrap = (txt) => suffix
      ? txt + '<span class="dogscan-results__suffix">' + suffix + '</span>'
      : txt;
    if (REDUCE || !target) { el.innerHTML = wrap(fmt(target || 0, decimals)); return; }
    const dur = 1500;
    const start = performance.now();
    function tick(now) {
      const t = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - t, 3);
      el.innerHTML = wrap(fmt(target * eased, decimals));
      if (t < 1) requestAnimationFrame(tick);
      else el.innerHTML = wrap(fmt(target, decimals));
    }
    requestAnimationFrame(tick);
  }

  class DogscanResults extends HTMLElement {
    connectedCallback() {
      this.observe('.dogscan-results__num', 0.6, (el) => runCount(el));
      this.observe('.dogscan-results__bar', 0.5, (el) => {
        setTimeout(() => el.classList.add('is-in'), 120);
      });
      this.observe('.dogscan-results__people', 0.6, (grp) => {
        const on = parseInt(grp.dataset.on, 10) || 0;
        const people = Array.from(grp.querySelectorAll('.dogscan-results__person'));
        people.forEach((s, i) => {
          setTimeout(() => {
            if (i < on) { s.classList.remove('off'); s.classList.add('on'); }
          }, 200 + i * 180);
        });
      });
    }

    observe(selector, threshold, fn) {
      const els = Array.from(this.querySelectorAll(selector));
      if (!els.length) return;
      if (REDUCE) { els.forEach(fn); return; }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          fn(e.target);
          io.unobserve(e.target);
        });
      }, { threshold });
      els.forEach((el) => io.observe(el));
    }
  }
  customElements.define('dogscan-results', DogscanResults);
}
